import * as S from './Education.styled'

const Education = ({ title, localEducation }) => {
  return (
    <div>
      <S.EducationTitle>{title}</S.EducationTitle>
      {localEducation.map((education, index) => (
        <S.EducationItem key={index}>{education}</S.EducationItem>
      ))}
    </div>
  )
}

export default Education
